import React, { Component } from "react";
import { connect } from "react-redux";

import { updateFirmName } from "../../actions/tenantActions";
import { LabeledTextInput } from "../TextInput";
import { ButtonWithIcon } from "../ButtonWithIcon";
import { LexWorkplaceCheckIcon } from "../LexWorkplaceIcons";
import SectionHeading from "../SectionHeading";

class FirmNameSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: props.firmName,
			submitting: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.submit = this.submit.bind(this);
	}
	handleChange(name, value) {
		this.setState({ [name]: value });
	}
	submit() {
		this.setState({ submitting: true });
		this.props
			.updateFirmName(this.state.name.trim())
			.catch(() => {})
			.finally(() => {
				this.setState({ submitting: false });
			});
	}
	render() {
		const trimmedName = (this.state.name || "").trim();
		const canSubmit =
			this.props.canEditFirmName &&
			!this.state.submitting &&
			trimmedName !== "" &&
			trimmedName !== this.props.firmName;

		return (
			<div>
				<SectionHeading>Firm Name</SectionHeading>
				<div
					title={
						this.props.canEditFirmName
							? undefined
							: "Only Firm Administrators can edit the Firm Name"
					}
				>
					<LabeledTextInput
						name="name"
						defaultValue={this.props.firmName}
						onChange={this.handleChange}
						disabled={!this.props.canEditFirmName}
						autocomplete="off"
					/>
				</div>
				{this.props.canEditFirmName ? (
					<>
						<div
							style={{
								color: "#666",
								fontSize: 13,
								margin: "6px 0",
							}}
						>
							The Firm Name you enter here will appear on the Home
							page for all users, as well as the name of the firm
							shown when sharing documents with outside parties.
						</div>
						<ButtonWithIcon
							handler={this.submit}
							disabled={!canSubmit}
							buttonText="Update Firm Name"
							iconComponent={<LexWorkplaceCheckIcon />}
						/>
					</>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	firmName: state.user.firmName,
	canEditFirmName: state.user.isFirmAdmin || state.user.isUptimeAdmin,
});

export default connect(mapStateToProps, { updateFirmName })(FirmNameSection);
